/**
 * Client (tenant) brand shown in the admin as "SpotEngine × {CLIENT_BRAND}".
 *
 * Single source of truth for the current client name. Today the admin serves
 * one client (FishSpot = tenant #1); when the multi-tenant API lands, replace
 * this constant with the brand resolved from tenant config / auth context.
 */
export const CLIENT_BRAND = 'FishSpot';
